import React, { Component } from 'react';
import { NormalButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { OUTPUT_TTL } from '../../constants/Pac';

@inject('batchStore')
@observer
class DustCollector extends Component {
  render() {
    const { device, batchStore } = this.props;
    const active = batchStore.isOutputOn(device.switchPNo) ? 'active' : '';
    const name = device.description || 'Dust Collector';
    const btnClass = active ? 'active btn-batch-red' : 'btn-batch-green';
    const duration = active ? 0 : OUTPUT_TTL;

    return (
      <div id={`device-${device.id}`} className={`${active} device-gui device-gui--dust-collector`}>
        <div className="device-label device-icon">
          <div className="device-type" title={`#${device.id}`}>{name}</div>
        </div>
        <div className="device-icon body"/>
        <div className="device-buttons">
          <NormalButton className={`btn-batch ${btnClass}`}
            port={device.switchPNo}
            duration={duration}>
            <i className="fa fa-power-off" />
          </NormalButton>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(DustCollector);
